export default "__VITE_ASSET__BncVh5Mi__"